import {styled} from '@mui/material';

export const CustomAlertContainer = styled('div')`
	background-color: ${({theme}) => theme.colors.gray['10Percent']};
	padding: 8px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	gap: 8px;
	text-align: left;
`;
